// src/pages/anime/AnimeEditPage.jsx
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AnimeEditSuggestionForm } from './AnimeEditSuggestionForm'
import { Loader } from '../../cmps/FarmerMotion/Loader'
import { loadAnimeById } from '../../controllers/animeDB.controller'

export function AnimeEditPage() {
  const { animeId } = useParams()
  const [anime, setAnime] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    if (!animeId) return
    setIsLoading(true)
    loadAnimeById(animeId)
      .then((data) => setAnime(data))
      .catch(() => setAnime(null))
      .finally(() => setIsLoading(false))
  }, [animeId])

  if (isLoading) return <Loader />
  if (!anime) return <div className="text-center text-red-400">לא נמצאה אנימה</div>

  return (
    <AnimeEditSuggestionForm
      anime={anime}
      onClose={() => navigate(-1)}
    />
  )
}
